import { FlexColumn, LabeledData } from '@gorila-shared-ui/components';
import { LabelMedium } from 'baseui/typography';
import { memo } from 'react';
import { useStyles } from '../../hooks/useStyles';

type Props = {
  container?: {
    identifier: string;
  };
};

function ContainerData({ container }: Props) {
  const { theme, classes } = useStyles();
  return (
    <FlexColumn gap={theme.sizing.scale200}>
      <LabelMedium className={classes.dataHeaderClass}>Datos del contenedor</LabelMedium>
      <FlexColumn
        gap={theme.sizing.scale200}
        classNames={classes.dataContentClass}
      >
        <LabeledData
          label="Identificador:"
          content={container?.identifier || '-'}
          labelWidth="100px"
          inline={false}
        />
      </FlexColumn>
    </FlexColumn>
  );
}

export default memo(ContainerData);
